import { BrowserRouter } from 'react-router-dom';
import Toast from './components/commonComponents/toast/ToastWrapper';
import Router from './routes/Index';
import { NotificationProvider } from './providers/NotificationProvider';
import { SocketProvider } from './providers/SocketProvider';
import { BrandPlanProvider } from './providers/BrandPlanProvider';

function App() {
  return (
    <SocketProvider>
      <NotificationProvider>
        <BrandPlanProvider>
          <BrowserRouter>
            <Router />
          </BrowserRouter>
          <Toast />
        </BrandPlanProvider>
      </NotificationProvider>
    </SocketProvider>
  );
}

export default App;
